import { ComplexBase } from '@syncfusion/ej2-react-base';
export class StackedColumnDirective extends ComplexBase {
}
StackedColumnDirective.moduleName = 'stackedColumn';
StackedColumnDirective.complexTemplate = { 'filterItemTemplate': 'filter.itemTemplate' };
export class StackedColumnsDirective extends ComplexBase {
}
StackedColumnsDirective.propertyName = 'columns';
StackedColumnsDirective.moduleName = 'stackedColumns';
